"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventInputNotNumberValue = void 0;
const helpers_1 = require("../../../../controls/NumberInput/helpers");
const preventInputNotNumberValue = (newValue, minValue, maxValue) => {
    if (newValue === '') {
        return false;
    }
    const { value, isInvalid } = (0, helpers_1.parseTextInputValue)(newValue);
    if (isInvalid) {
        return true;
    }
    if ((Number(value) || 0) > maxValue || (Number(value) || 0) < minValue) {
        return true;
    }
    const numberValue = (0, helpers_1.parseTextToNumber)(value);
    return numberValue === undefined;
};
exports.preventInputNotNumberValue = preventInputNotNumberValue;
//# sourceMappingURL=preventInputNotNumberValue.js.map